import React from 'react'

import '../Style/styles.css'
function Announcement() {
  return (
    <div className='A1'>
        <p className='A2'>
            <p>Offers</p>
            <h1>|</h1>
            <p>Fanbook</p>
            <h1>|</h1>
            <p>Download App</p>
            <h1>|</h1>
            <p>TriBe Membership</p>
        </p>
        
        <p className='A3'>
                <p>Contact Us</p>
                <h1>|</h1>
                <p>Track Order</p>
        </p>
    </div>
  )
}

export default Announcement